import * as React from "react";
import { Row, Col } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReceiverCheckbox } from "./ReceiverCheckbox";
import { formatUsername } from "utils/formatUsername";

interface GroupsModalItemProps {
  state: { [key: string]: string[] | string };
  data: API_Group;
  onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export class GroupsModalItem extends React.Component<GroupsModalItemProps, { hover: number }> {
  constructor(props: GroupsModalItemProps) {
    super(props);
    this.state = {
      hover: -1,
    };
  }

  hoverState = (index) => {
    if (this.state.hover === index) {
      return "groups-hover";
    }
    return "groups-unhover";
  };

  render() {
    const { state, data, onCheckboxChange } = this.props;
    const { id, name, groupMembers, type } = data;
    const members = groupMembers
      ? groupMembers
          .map((item) => `${formatUsername({ firstName: item.firstName, surname: item.surname })} / ${item.mail}`)
          .join(", ")
      : null;
    const isLock = type === "PRIVATE" && (
      <span className="avatar-lock">
        <FontAwesomeIcon icon={["fas", "lock"]} fixedWidth={true} className="icon" />
      </span>
    );

    return (
      <Row
        key={name}
        className="modal-item"
        justify="space-between"
        align="middle"
        onMouseEnter={() => this.setState({ hover: id })}
        onMouseLeave={() => this.setState({ hover: -1 })}
      >
        <Col xs={2} className="avatar">
          <FontAwesomeIcon icon={["fas", "users"]} fixedWidth={true} className="icon" />
          {isLock}
        </Col>
        <Col xs={14}> {name} </Col>
        <Col xs={7}>
          <div className="checkbox-cc-bcc">
            {["to", "cc", "bcc"].map((filedType) => {
              return (
                <ReceiverCheckbox
                  key={filedType}
                  checked={!!state[filedType] && !!state[filedType].includes(`@group${id}`)}
                  type={filedType}
                  value={`@group${id}`}
                  onChange={onCheckboxChange}
                />
              );
            })}
          </div>
        </Col>
        {members && (
          <Col xs={24} className={this.hoverState(id)}>
            {members}
          </Col>
        )}
      </Row>
    );
  }
}
